<div class="inner-content file-upload">
  <main class="modal-ins-wrapper">
    <div class="ion-text-right">
      <ion-button fill="clear" class="close-modal-button" slot="end" (click)="dismissModal()" id="closeButton">
        <ion-icon name="wg-outline-multiply"></ion-icon>
      </ion-button>
    </div>
    <ion-grid>
      <ion-row>
        <ion-col class="header">
          <h1 class="wg-h-md">{{ title }}</h1>
          <p>{{ subtitle }}</p>
        </ion-col>
      </ion-row>
      <ion-row [hidden]="file">
        <ion-col>
          <ngx-dropzone
            (change)="onSelect($event)"
            [multiple]="false"
            [accept]="accept"
            [maxFileSize]="maxFileSizeBytes"
            #dropzone
            [class.has-errors]="this.errors.length"
            [class.processing-file]="processingFile"
            (click)="chooseFile()"
          >
            <ngx-dropzone-label>
              <div *ngIf="processingFile; else defaultLabel">
                <ion-spinner name="crescent" color="primary"></ion-spinner>
                <p>{{ 'FileUpload.fileProcessing' | translate }}</p>
                <p class="small">{{ 'FileUpload.clickToReupload' | translate }}</p>
              </div>
              <ng-template #defaultLabel>
                <img src="../../../assets/images/upload.svg" alt="upload" />
                <p>{{ tapToUploadText }}</p>
              </ng-template>
            </ngx-dropzone-label>
          </ngx-dropzone>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="!file">
        <ion-col>
          <p class="max-size">{{ 'FileUpload.maxSize' | translate }}: {{ maxFileSizeMb }}MB</p>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="file">
        <ion-col>
          <div class="file-preview" #filePreview (window:resize)="onResize()">
            <div>
              <div class="thumb">
                <img src="../../../assets/images/video.svg" alt="video" *ngIf="fileType === 'video'" />
                <img src="../../../assets/images/image.svg" alt="image" *ngIf="fileType === 'image'" />
              </div>
              <div class="content">
                <div class="filename">{{ file.name | truncate: this.maxFilenameLength }}</div>
                <div class="filesize">{{ file.size | humanFileSize }}</div>
              </div>
              <div class="status">
                <img src="../../../assets/images/tick-green.svg" alt="ok" />
              </div>
            </div>
            <div class="action">
              <a href="javascript:void(0)" (click)="deleteFile()">{{ 'FileUpload.remove' | translate }}</a>
              <a href="javascript:void(0)" (click)="replaceFile()">{{ 'FileUpload.replace' | translate }}</a>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="errors.length > 0">
        <ion-col>
          <app-form-error-messages [errors]="errors" *ngIf="errors.length" paddingLeft="0" fontSize="sm"></app-form-error-messages>
        </ion-col>
      </ion-row>

      <ion-row class="row-button">
        <ion-col>
          <ion-button expand="block" (click)="submit()" color="primary" [disabled]="!file">
            <span>
              {{ 'ProgramCodePage.continue' | translate }}
            </span>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </main>
</div>

<!-- this element is hidden and only required for fetching thumbnail from selected video -->
<div class="video-thumbnail">
  <video id="video-element" controls muted playsinline></video>
  <canvas id="canvas-element"></canvas>
</div>
